<section>
	<!-- Filter -->
	<lvr-field class="filter">
		<mat-form-field lvrInput>
			<mat-select
				multiple
				[value]="selectedCategoriesArray()"
				(selectionChange)="onCategoryFilterChange($event.value)"
				[disabled]="loading()"
				[placeholder]="'client.documents.select_categories' | transloco"
			>
				@for (opt of DOCUMENT_FILTER_OPTIONS(); track $index) {
					<mat-option [value]="opt">
						{{ mapDocumentCategoryToKey(opt) | transloco }}
					</mat-option>
				}
			</mat-select>
		</mat-form-field>
	</lvr-field>

	<!-- Table -->
	<table mat-table [dataSource]="displayedDocuments()" class="mat-elevation-z2">
		<ng-container matColumnDef="name">
			<th mat-header-cell *matHeaderCellDef>{{ 'client.documents.name' | transloco }}</th>
			<td mat-cell *matCellDef="let doc">
				@if (doc.name.trim()) {
					{{ doc.name.trim() }}
				} @else {
					@if (doc.category === DOCUMENT_CATEGORY.CONTACT) {
						{{ 'client.documents.contact_on' | transloco: { date: formatDate(doc.createdAt) } }}
					} @else {
						-
					}
				}
			</td>
		</ng-container>

		<ng-container matColumnDef="date">
			<th mat-header-cell *matHeaderCellDef>{{ 'client.documents.date' | transloco }}</th>
			<td mat-cell *matCellDef="let doc">
				<div class="items">
					@if (doc.externalFileReference?.length) {
						@for (file of doc.externalFileReference; track file.id) {
							<span class="docs-date">{{ formatDate(file.createdAt) }}</span>
						}
					} @else {
						{{ formatDate(doc.createdAt) }}
					}
				</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="files">
			<th mat-header-cell *matHeaderCellDef>{{ 'client.documents.files' | transloco }}</th>
			<td mat-cell *matCellDef="let doc">
				<div class="items">
					@if (doc.isReport) {
						@if (doc.externalFileReference?.length) {
							@for (file of doc.externalFileReference; track file.id) {
								<lvr-document-item [document]="file" (open)="onFileClick(file)"></lvr-document-item>
							}
						} @else {
							<lvr-document-item [document]="doc" (open)="onReportClick(doc)"></lvr-document-item>
						}
					} @else {
						@if (doc.externalFileReference?.length) {
							@for (file of doc.externalFileReference; track $index) {
								<lvr-document-item [document]="file" (open)="onFileClick(file)"></lvr-document-item>
							}
						} @else {
							<span>-</span>
						}
					}
				</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="category">
			<th mat-header-cell *matHeaderCellDef>{{ 'client.documents.category' | transloco }}</th>
			<td mat-cell *matCellDef="let doc">
				{{ mapDocumentCategoryToKey(doc.category) | transloco }}
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>

	<!-- Empty state -->
	@if (!loading() && documentsRaw().length === 0) {
		<div class="empty">
			{{ 'client.documents.no_documents' | transloco }}
		</div>
	}

	<!-- Pagination -->
	<lvr-paginator
		[length]="totalItems()"
		[pageSize]="pageSize()"
		[pageIndex]="pageIndex()"
		[showFirstLastButtons]="true"
		[hidePageSize]="false"
		[disabled]="loading()"
		preferenceKey="documents-list"
		(page)="handlePageEvent($event)"
	>
	</lvr-paginator>
</section>
